import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = { id: "footer" }
const _hoisted_3 = { class: "links" }

import { ref } from 'vue';
import SidebarComponent from '@/components/SidebarComponent.vue';
import { APP_VERSION } from '@/constants';


export default /*@__PURE__*/_defineComponent({
  __name: 'AuthenticatedLayout',
  setup(__props) {

const isSidebarToggled = ref(false);

// Listen to an event emitted from SidebarComponent to update `isSidebarToggled`
function handleSidebarToggle(toggled: boolean) {
  isSidebarToggled.value = toggled;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SidebarComponent, { onToggle: handleSidebarToggle }),
    _createElementVNode("div", {
      id: "content",
      class: _normalizeClass({ 'sidebar-visibility-toggled': isSidebarToggled.value })
    }, [
      _createElementVNode("div", null, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _createElementVNode("div", _hoisted_2, [
        _cache[3] || (_cache[3] = _createElementVNode("p", { class: "copyright" }, " © Sampling Human, Inc. All Rights Reserved. ", -1)),
        _createElementVNode("p", _hoisted_3, [
          _cache[0] || (_cache[0] = _createElementVNode("a", {
            href: "https://www.samplinghuman.com/terms-and-conditions",
            target: "_blank",
            rel: "noopener noreferrer"
          }, " Terms and Conditions ", -1)),
          _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
          _createTextVNode(" " + _toDisplayString(_unref(APP_VERSION)) + " ", 1),
          _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1))
        ])
      ])
    ], 2)
  ]))
}
}

})